'use client';

import { useEffect } from 'react';

import { ErrorFallback } from '@/ui';

export default function Error({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className={'flex h-dvh w-full place-content-center'}>
      <ErrorFallback />
    </div>
  );
}
